<template>
  <div style="width: 100%">
    <div class="klinechart" id="klinechart" ref="chartContainer"></div>
  </div>
</template>

<script>
import { CustomDatafeed } from "@/utils/CustomDatafeed";

export default {
  props: {
    bi: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
      datafeed: null,
    };
  },
  async mounted() {
    await this.initChart();
  },
  methods: {
    async initChart() {
      this.datafeed = new CustomDatafeed();

      // 初始化图表
      this.chart = new window.klinechartspro.KLineChartPro({
        container: document.getElementById("klinechart"),
        // 初始化标的信息
        symbol: {
          exchange: "Binance",
          market: "Crypto",
          name: this.bi.ename,
          shortName: this.bi.ename,
          ticker: this.bi.ename,
          priceCurrency: "USDT",
          type: "Crypto",
          pricePrecision: this.bi.decimal_points,
          volumePrecision: 3,
        },
        // 初始化周期
        period: {
          multiplier: 1,
          timespan: "minute",
          text: "1M",
        },
        periods: [
          {
            text: "1M",
            timespan: "minute",
            multiplier: 1,
          },
          {
            text: "5M",
            timespan: "minute",
            multiplier: 5,
          },
          {
            text: "15M",
            timespan: "minute",
            multiplier: 15,
          },
          {
            text: "1H",
            timespan: "hour",
            multiplier: 1,
          },
          {
            text: "D",
            timespan: "day",
            multiplier: 1,
          },
        ],
        // 使用自定义数据源
        datafeed: this.datafeed,
        theme: this.$store.state.theme ? "light" : "dark",
        watermark: "",
        locale: "en-US",
        mainIndicators: [],
        subIndicators: [],
      });
      const styles = this.chart.getStyles();
      styles.candle.bar.upColor = "blue";
      styles.candle.bar.upBorderColor = "blue";
      styles.candle.bar.upWickColor = "blue";
      styles.candle.bar.downColor = "red";
      styles.candle.bar.downBorderColor = "red";
      styles.candle.bar.downWickColor = "red";
      this.chart.setStyles(styles);
      console.log(this.chart);
    },
  },

  // 组件销毁时清理资源
  beforeUnmount() {
    CustomDatafeed.cleanupAll();
    // if (this.chart) {
    //   this.chart.destroy();
    //   this.chart = null;
    // }
  },

  // 监听属性变化
  watch: {
    bi: {
      deep: true,
      handler(newVal) {
        console.log("改变")
        if (this.chart) {
          this.chart.setSymbol({
            exchange: "Binance",
            market: "Crypto",
            name: this.bi.ename,
            shortName: this.bi.ename,
            ticker: this.bi.ename,
            priceCurrency: "USDT",
            type: "Crypto",
            pricePrecision: this.bi.decimal_points,
            volumePrecision: 3,
          });
        }
      },
    },
    "$store.state.theme"(newTheme) {
      if (this.chart) {
        this.chart.setTheme(newTheme ? "light" : "dark");
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .klinecharts-pro-period-bar {
  .item.tools {
    display: none;
  }
  & > .symbol {
    pointer-events: none;
  }
}
.klinechart {
  width: 100%;
  height: 600px;
  background: var(--chart-bg, #fff);
}

.dark .klinechart {
  --chart-bg: #1e2126;
}
</style>
